import { useGenericPopover } from '../generic-popover';
import {
  DeleteTaskPopover,
  DeleteTaskPopoverProps,
} from './delete-task-popover';

export const useDeleteTaskPopover = ({
  taskName,
  testId,
  onClose,
  onDelete,
  ...restProps
}: Partial<DeleteTaskPopoverProps>) => {
  const { onClose: onClosePopover, trigger, popoverRef } = useGenericPopover();

  const deleteTaskPopover = (
    <DeleteTaskPopover
      {...restProps}
      trigger={trigger}
      popoverRef={popoverRef}
      testId={testId}
      taskName={taskName}
      onDelete={onDelete}
      onClose={onClosePopover}
    />
  );

  return {
    deleteTaskPopover,
    trigger,
  };
};
